import { from, iif, Observable, of, switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { requiredHeaders } from '../../models/required-headers';
import { applySchema } from '../../utils/apply-schema';
import { normalizeCallBehavior } from '../../utils/normalize-call-behavior';
import { normalizeErrorReporting } from '../../utils/normalize-error-reporting';
import { authwsEnvironment } from './authws-environment';
import { AuthUser } from './schemas/auth-user.schema';
import { authenticateResponseSchema } from './schemas/authenticate-response.schema';

interface authTidRequestOptions {
  redirectUrl: string;
  applicationName?: string;
  trimbleApplication: string;
}

/**
 * @param authCode authorization code from TID redirect
 * @param requestOptions TID Authentication Request Options
 */
export function postTidAuthenticate(
  authCode: string,
  requestOptions: authTidRequestOptions
): Observable<AuthUser>;
/**
 * @param authCode authorization code from TID redirect
 * @param requestOptions TID Authentication Request Options
 * @param account selected account
 */
export function postTidAuthenticate(
  authCode: string,
  requestOptions: authTidRequestOptions,
  account?: string
): Observable<AuthUser>;
export function postTidAuthenticate(
  arg1: string,
  arg2: authTidRequestOptions,
  arg3?: string
) {
  const request: Record<string, unknown> = {
    authorizationCode: arg1,
    redirectUrl: arg2.redirectUrl,
    trimbleApplication: arg2.trimbleApplication,
  };

  if (arg2?.applicationName) {
    request.applicationName = arg2.applicationName;
  }

  if (arg3) {
    request.account = arg3;
  }

  return fromFetch(
    new Request(authwsEnvironment.tidAuthenticateUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      credentials: 'include',
      body: JSON.stringify(request),
    })
  ).pipe(
    switchMap((response: Response) => {
      return response.status === 400 ? from(response.json()) : of(response);
    }),
    switchMap((response: Observable<unknown>) => {
      return iif(
        () => response instanceof Response,
        of(response) as unknown as Observable<Response>,
        of(
          new Response(JSON.stringify(response), {
            status: (response as unknown as Record<string, unknown>)?.accounts
              ? 200
              : 400,
          })
        )
      );
    }),
    normalizeCallBehavior(),
    applySchema(authenticateResponseSchema),
    normalizeErrorReporting()
  );
}
